export enum PreferenceCoverageShortNameEnum {
  ms = 'ms',
  ma = 'ma',
  pdp = 'pdp',
}
